import { getKPIRequest } from "@/api/getKPIRequest"

export const getRPMLoaded = async (): Promise<number> => {
  const kpis = await getKPIRequest({
    aggType: "Monthly",
    returnSize: 1,
    kpis: [
      {
        $type: "basic",
        typeId: 1,
        id: 431,
      },
      {
        $type: "basic",
        typeId: 1,
        id: 500,
      },
    ],
  })
  const miles = kpis.at(0)?.values?.at(0)?.value
  const revenue = kpis.at(1)?.values?.at(0)?.value
  return miles && revenue ? revenue / miles : 0
}
